module.exports = "/remote-dist/d1ec34a1f75317be63643f4cab226508.jpg";